import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import * as TranslationEsUS from "./locales/en-US/translations.json";
import * as TranslationEsGB from "./locales/en-GB/translations.json";
import * as TranslationdeDE from "./locales/de-DE/translations.json";
import * as TranslationesES from "./locales/es-ES/translations.json";
import * as TranslationesMX from "./locales/es-MX/translations.json";
import * as TranslationfrCA from "./locales/fr-CA/translations.json";
import * as TranslationfrFR from "./locales/fr-FR/translations.json";
import * as TranslationitIT from "./locales/it-IT/translations.json";
import * as TranslationjaJP from "./locales/ja-JP/translations.json";
import * as TranslationkoKR from "./locales/ko-KR/translations.json";
import * as TranslationnlNL from "./locales/nl-NL/translations.json";
import * as TranslationplPL from "./locales/pl-PL/translations.json";
import * as TranslationptBR from "./locales/pt-BR/translations.json";
import * as TranslationruRU from "./locales/ru-RU/translations.json";
import * as TranslationthTH from "./locales/th-TH/translations.json";
import * as TranslationtrTR from "./locales/tr-TR/translations.json";
import * as TranslationviVN from "./locales/vi-VN/translations.json";
import * as TranslationzhCN from "./locales/zh-CN/translations.json";
import * as TranslationzhTW from "./locales/zh-TW/translations.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: true,
    lng: "en-US",
    fallbackLng: "en-US", // use en if detected lng is not available
    // keySeparator: false, // we do not use keys in form messages.welcome
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources: {
      "en-US": {
        translations: TranslationEsUS,
      },
      "en-GB": {
        translations: TranslationEsGB,
      },
      "de-DE": {
        translations: TranslationdeDE,
      },
      "es-ES": {
        translations: TranslationesES,
      },
      "es-MX": {
        translations: TranslationesMX,
      },
      "fr-CA": {
        translations: TranslationfrCA,
      },
      "fr-FR": {
        translations: TranslationfrFR,
      },
      "it-IT": {
        translations: TranslationitIT,
      },
      "ja-JP": {
        translations: TranslationjaJP,
      },
      "ko-KR": {
        translations: TranslationkoKR,
      },
      "nl-NL": {
        translations: TranslationnlNL,
      },
      "pl-PL": {
        translations: TranslationplPL,
      },
      "pt-BR": {
        translations: TranslationptBR,
      },
      "ru-RU": {
        translations: TranslationruRU,
      },
      "th-TH": {
        translations: TranslationthTH,
      },
      "tr-TR": {
        translations: TranslationtrTR,
      },
      "vi-VN": {
        translations: TranslationviVN,
      },
      "zh-CN": {
        translations: TranslationzhCN,
      },
      "zh-TW": {
        translations: TranslationzhTW,
      },
    },
    // have a common namespace used around the full app
  });

export default i18n;
